import PDF_1 from '~/assets/images/pdf/pdf_template_1.png';
import PDF_2 from '~/assets/images/pdf/pdf_template_2.png';
import PDF_3 from '~/assets/images/pdf/pdf_template_3.png';
import PDF_4 from '~/assets/images/pdf/pdf_template_4.png';
import PDF_0 from '~/assets/images/pdf/pdf_template_default.png';

export const templatesImages = (t) => [
  {
    title: t('other:default'),
    component: PDF_0,
  },
  {
    title: t('other:template', { templateId: 1 }),
    component: PDF_1,
  },
  {
    title: t('other:template', { templateId: 2 }),
    component: PDF_2,
  },
  {
    title: t('other:template', { templateId: 3 }),
    component: PDF_3,
  },
  {
    title: t('other:template', { templateId: 4 }),
    component: PDF_4,
  },
];

export const pdfForms = [
  {
    label: 'other:company',
    value: 'Example',
    id: 'company',
    maxLength: 100,
    placeholder: 'common:enterCompanyName',
  },
  {
    label: 'other:title',
    value: 'Example',
    id: 'title',
    maxLength: 100,
    placeholder: 'common:enterTitleName',
  },
  {
    label: 'other:description',
    value: 'Example',
    id: 'description',
    maxLength: 200,
    placeholder: 'common:enterDescription',
  },
  {
    label: 'titles:link',
    value: 'Example',
    id: 'website',
    maxLength: 2000,
  },
  {
    label: 'other:button',
    value: 'Example',
    id: 'button',
    onlyTemplateId: 1,
    maxLength: 25,
  },
];
